export default "//0f174046-a3c4-46d7-88af-9cfef9e6bcb2.selcdn.net/webpack/production/eda69e7d151c9197185175980004f5c2.svg";